import { render } from "./EditProject.vue?vue&type=template&id=361a65e0&scoped=true"
import script from "./EditProject.vue?vue&type=script&lang=js"
export * from "./EditProject.vue?vue&type=script&lang=js"

import "./EditProject.vue?vue&type=style&index=0&id=361a65e0&lang=scss&scoped=true"
import "./EditProject.vue?vue&type=style&index=1&id=361a65e0&lang=scss"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361a65e0"]])

export default __exports__